// extracted by mini-css-extract-plugin
export default {"root":"RenderValue_root__ChiD5","fraction":"RenderValue_fraction__Me7UE","currency":"RenderValue_currency__nc3Xb","placeHolderShimmer":"RenderValue_placeHolderShimmer__Ogx65"};